/**
 * @packageDocumentation
 * @module f1/array
 */

import { I } from '../core/immutable';

export interface Dequeue {
  /**
   * Remove the top-most item from a queue (e.g. same as `shift`)
   *
   * @public
   * @function f1.dequeue
   * @param arr the array to remove an item from the beginning
   * @example
   *
   * ```ts
   * f1.dequeue([1, 2, 3]) => [2, 3]
   * ```
   *
   */
  <T>(arr: T[]): T[];
}

/**
 * @see Dequeue
 */
export default <T>(arr: T[]): T[] => {
  const _arr = I.array(arr);

  _arr.shift();
  return _arr;
};
